import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Religion = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="religion icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M28 2H20V14H8V22H20V46H28V22H40V14H28V2ZM42 12V24H30V48H18V24H6V12H18V0L30 0V12H42Z"
    />
  </svg>
)
